import { useState } from 'react';

const services = [
  {
    icon: 'ri-instagram-line',
    title: 'Gestión de redes sociales',
    description: 'Administro tus redes sociales de forma profesional, creando contenido estratégico que conecta con tu audiencia y genera engagement real.'
  },
  {
    icon: 'ri-video-line',
    title: 'Creación de contenido',
    description: 'Diseño Reels, historias y posts que captan la atención, cuentan tu historia y convierten seguidores en clientes fieles.'
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Estrategia digital',
    description: 'Desarrollo estrategias personalizadas basadas en análisis de tu marca, competencia y audiencia para maximizar resultados.'
  },
  {
    icon: 'ri-palette-line',
    title: 'Diseño gráfico para redes',
    description: 'Creo diseños visuales atractivos y coherentes que reflejan la identidad de tu marca y destacan en el feed.'
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Asesorías personalizadas',
    description: 'Sesiones individuales donde te guío paso a paso para que domines tus redes sociales y alcances tus objetivos.'
  },
  {
    icon: 'ri-rocket-line',
    title: 'Lanzamientos y campañas',
    description: 'Planifico y ejecuto lanzamientos de productos o servicios con campañas que generan expectativa y ventas.'
  }
];

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="servicios" className="py-24 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Título */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-pink-400"></div>
            <h2 className="text-4xl md:text-5xl font-bold text-purple-900">
              Servicios que impulsan tu marca
            </h2>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-pink-400"></div>
          </div>
          <p className="text-gray-600 text-lg mt-4">
            Soluciones completas para hacer crecer tu presencia digital
          </p>
        </div>

        {/* Grid de servicios */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Borde superior gradiente */}
              <div
                className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-pink-500 to-purple-600 rounded-t-3xl transition-all duration-300 ${
                  hoveredIndex === index ? 'opacity-100' : 'opacity-0'
                }`}
              ></div>

              {/* Icono */}
              <div className="mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
              </div>

              {/* Contenido */}
              <h3 className="text-xl font-bold text-purple-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>

              {/* Flecha decorativa */}
              <div
                className={`absolute bottom-6 right-6 w-8 h-8 flex items-center justify-center text-pink-500 transition-all duration-300 ${
                  hoveredIndex === index ? 'translate-x-1 -translate-y-1' : ''
                }`}
              >
                <i className="ri-arrow-right-up-line text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
